import React, { useEffect } from 'react';
import useAsync from 'react-use/lib/useAsync';
import { Progress } from '@backstage/core-components';
import { useUserBadges } from '../../hooks/useBadges';
import { useEntity } from '@backstage/plugin-catalog-react';
import { stringifyEntityRef } from '@backstage/catalog-model';
import Grid from '@material-ui/core/Grid';
import firstBlood from '../../../public/images/firstblood.png';
import freshman from '../../../public/images/freshman.png';
import gaffer from '../../../public/images/gaffer.png';
import highperformer from '../../../public/images/highperformer.png';
import inventor from '../../../public/images/inventor.png';
import level1 from '../../../public/images/level1.png';
import noob from '../../../public/images/noob.png';
import padawan from '../../../public/images/padawan.png';
import star from '../../../public/images/star.png';

const assets: { [key: string]: string } = {
  firstblood: firstBlood,
  freshman: freshman,
  gaffer: gaffer,
  highperformer: highperformer,
  inventor: inventor,
  level1: level1,
  noob: noob,
  padawan: padawan,
  star: star,
};
export const Badges = ({
  onBadgeCheck,
  showNames = true,
}: {
  onBadgeCheck: Function;
  showNames?: boolean;
}) => {
  const fetchUserBadgesApi = useUserBadges();
  const { entity } = useEntity();
  const ref = stringifyEntityRef({
    kind: entity.kind,
    namespace: entity.metadata.namespace,
    name: entity.metadata.name,
  });

  const { value: badges, loading } = useAsync(async () => {
    return fetchUserBadgesApi(ref);
  }, []);

  useEffect(() => {
    onBadgeCheck(badges ? badges.length : loading ? 1 : 0);
  }, [badges, loading, onBadgeCheck]);

  if (loading) {
    return <Progress />;
  }
  if (!badges || Object.keys(badges).length === 0) {
    return <></>;
  }

  return (
    <Grid container spacing={3} alignItems="flex-start">
      {badges.map(badge => (
        <Grid
          item
          xs={12}
          sm={2}
          xl={1}
          style={{
            height: '150px',
            position: 'relative',
            paddingBottom: '30px',
            textAlign: 'center',
            marginBottom: '10px',
          }}
        >
          <img
            src={assets[badge.image]}
            alt={badge.name}
            style={{ width: '100%' }}
          />
          {(showNames === undefined || showNames) && (
            <>
              <div
                style={{
                  textAlign: 'center',
                  position: 'absolute',
                  bottom: '0',
                  width: '100%',
                  left: '0px',
                }}
              >
                {badge.name}
              </div>
            </>
          )}
        </Grid>
      ))}
    </Grid>
  );
};
